module.exports = __webpack_public_path__ + "static/media/search.adccfd63.svg";